var lib_core = require("lib-core");

var SettingsStateMachine = require("./settingsStateMachine.js");

var SettingsController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    // Define possible events
    lib_core.GuiEvents.addEvents({
        SETTINGS_FOCUS:              {id: 'set_01', name: "SETTINGS_FOCUS"             },
        SETTINGS_BLUR:               {id: 'set_02', name: "SETTINGS_BLUR"              },
        CHANGE_SETTING:              {id: 'set_03', name: "CHANGE_SETTING"             },
        TOGGLE_PUBLICATION_STATUS:   {id: 'set_04', name: "TOGGLE_PUBLICATION_STATUS"  }
    });

};

lib_core.inherit(SettingsController, lib_core.Controller);

module.exports = SettingsController;

SettingsController.prototype.createStateMachine = function () {
    throw new Error("Override this method");
};

SettingsController.prototype.createView = function () {
    throw new Error("Override this method");
};

SettingsController.prototype.createModel = function () {
    throw new Error("Override this method");
};

SettingsController.prototype.getData = function () {
    console.assert(this.configuration.data, "No data was given to the settingsController");
    return this.root.findByPath(this.configuration.data);
};
